import gsap from "gsap";

export default function initHome() {
    const heroHome = document.querySelector('.hero__home');
    if (!heroHome) return;

    const lenis = window.lenis;
    const introPlayed = sessionStorage.getItem('introPlayed');

    // Block scroll initially
    if (lenis && !introPlayed) lenis.stop();

    const intro = document.getElementById('intro');
    const video = intro ? intro.querySelector('video') : null;

    const targets = heroHome.querySelectorAll('.hero__home__video img, .play-video, p');

    gsap.set(targets, {
        opacity: 0,
        y: 30,
    });

    function playIntroAnimations() {
        gsap.to(targets, {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: 'power2.out',
            stagger: 0.2
        });
    }

    const restoreScroll = () => {
        if (!heroHome.isConnected) return;
        if (lenis) lenis.start();
        sessionStorage.setItem('introPlayed', 'true');
        gsap.to(intro, {
            opacity: 0,
            duration: 0.5,
            onComplete: () => {
                if (intro) intro.style.display = 'none';
                playIntroAnimations();
            }
        });
    }

    if (video && !introPlayed) {
        video.play().catch(e => {
            console.log('Autoplay prevented:', e);
            restoreScroll();
        });

        video.addEventListener('ended', restoreScroll);

        setTimeout(() => {
            if (lenis && lenis.isStopped) restoreScroll();
        }, 10000);

    } else {
        if (intro) intro.style.display = 'none';
        if (lenis) lenis.start();
        sessionStorage.setItem('introPlayed', 'true');
        playIntroAnimations();
    }
}
